var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBrandFeatures(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_11162",
    "data-name": "Group 11162",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 130,
    height: 130,
    viewBox: "0 0 130 130",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4265",
    "data-name": "Rectangle 4265",
    width: 130,
    height: 130,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11098",
    "data-name": "Group 11098",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44799",
    "data-name": "Path 44799",
    d: "M130,65C128.541,151.674,1.447,151.66,0,65,1.459-21.674,128.553-21.66,130,65",
    transform: "translate(0 0)",
    fill: "#ffcd05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44800",
    "data-name": "Path 44800",
    d: "M170.805,194.394c11.311-.843,16.364,13.97,7.293,20.6a14.307,14.307,0,0,1,6.6,8.342,32.724,32.724,0,0,1,.414,8.719,1.709,1.709,0,0,1-1.167,1.4l-24.19.11a2.073,2.073,0,0,1-1.7-1.1,49.424,49.424,0,0,1-.045-7.188c.39-4.246,3.419-8.172,7-10.28-8.408-6.316-4.9-19.8,5.795-20.6",
    transform: "translate(-106.585 -131.193)",
    fill: "#d9261c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44801",
    "data-name": "Path 44801",
    d: "M124.753,219.035c-2.711-.225-5.872.3-8.526,0-.616-.07-1.6-.337-1.865-.938a50.16,50.16,0,0,1-.117-7.349,13.222,13.222,0,0,1,7-10.168l-.148-.482c-9.108-6.7-3.554-21.245,7.736-20.3,1.971.166,5.033,1.278,6.193,2.913a15.061,15.061,0,0,0-4.963,21.959,19.123,19.123,0,0,0-5.312,14.363",
    transform: "translate(-77.065 -121.336)",
    fill: "#d9261c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44802",
    "data-name": "Path 44802",
    d: "M235.246,200.154l.145.482a13.535,13.535,0,0,1,6.856,10.144,45.4,45.4,0,0,1,0,7,1.261,1.261,0,0,1-.574.827c-1.475,1.11-7.832.123-9.931.465a19.123,19.123,0,0,0-5.312-14.362,15.061,15.061,0,0,0-4.963-21.959c1.828-2.274,5.657-3.179,8.5-2.888,10.068,1.032,13.718,14.679,5.285,20.295",
    transform: "translate(-149.489 -121.369)",
    fill: "#d9261c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44803",
    "data-name": "Path 44803",
    d: "M185.8,99.4a1.445,1.445,0,0,1-.074,1.8c-.948,1.487-4.907,3.95-5.2,5.319-.371,1.734,1.572,6.738,1,8a1.177,1.177,0,0,1-1.517.6c-1.7-.472-5.292-3.309-6.671-3.4-1.468-.1-6.308,3.818-7.636,3.466a1.443,1.443,0,0,1-.881-1.467c.016-1.817,1.483-5.573,1.135-7.2-.372-1.741-5.573-4.417-5.552-6.343a1.2,1.2,0,0,1,.379-.854c1.483-.913,6.53-.438,8.016-1.5,1.2-.86,2.8-6.739,3.9-7.077a1.806,1.806,0,0,1,1.241.073c.949.463,2.619,6.2,3.738,7,1.332.953,7.274.762,8.116,1.575",
    transform: "translate(-108.278 -61.203)",
    fill: "#d9261c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44804",
    "data-name": "Path 44804",
    d: "M116.05,116.416c1.875-.312,7.263-.65,6.262,2.524-.486,1.542-5.663,1.433-6.914,1.052-1.812-.552-1.633-3.2.652-3.577",
    transform: "translate(-77.066 -78.451)",
    fill: "#d9261c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44805",
    "data-name": "Path 44805",
    d: "M261.912,116.42c1.9-.316,7.282-.637,6.319,2.581-.444,1.484-4.594,1.232-5.917,1.109-2.977-.277-2.986-3.259-.4-3.69",
    transform: "translate(-175.517 -78.455)",
    fill: "#d9261c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44806",
    "data-name": "Path 44806",
    d: "M128.908,87.643a1.822,1.822,0,0,1-1.662,2.966c-.817-.108-5.295-2.32-5.621-3.036a1.841,1.841,0,0,1,1.841-2.562,35.619,35.619,0,0,1,5.443,2.633",
    transform: "translate(-81.99 -57.375)",
    fill: "#d9261c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44807",
    "data-name": "Path 44807",
    d: "M254.609,87.643a40.028,40.028,0,0,1,5.443-2.633,1.841,1.841,0,0,1,1.841,2.562c-.327.717-4.8,2.929-5.621,3.036a1.822,1.822,0,0,1-1.662-2.966",
    transform: "translate(-171.587 -57.375)",
    fill: "#d9261c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44808",
    "data-name": "Path 44808",
    d: "M127.249,142.607a1.816,1.816,0,0,1,1.444,3.1,52.649,52.649,0,0,1-4.829,2.411c-2.038.433-3.273-1.629-1.821-2.988a33.137,33.137,0,0,1,5.206-2.523",
    transform: "translate(-81.952 -96.249)",
    fill: "#d9261c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44809",
    "data-name": "Path 44809",
    d: "M255.763,142.611c.725-.131,5.023,1.9,5.658,2.425,1.61,1.334.447,3.545-1.69,3.09a52.775,52.775,0,0,1-4.829-2.411,1.87,1.87,0,0,1,.862-3.105",
    transform: "translate(-171.704 -96.259)",
    fill: "#d9261c"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandFeatures);
export default __webpack_public_path__ + "static/media/brand-features.51abf079ff467420465a52d52ec0bcff.svg";
export { ForwardRef as ReactComponent };